import { holdCausesIn } from '../../domain/services/holdCauses';
import { watchHeldItemsAbout } from '../../infrastructure/api/billingItemApi';
import { useLatestWatch } from './useLatestWatch';

/**
 * Which causes a task's held items have, followed while the task is shown, so fixing one cause drops
 * it. Empty while it reads or when nothing could be read; the card then says what is wrong in general.
 *
 * @param {() => {clinicId: string|null, field: string, value: string|null, holdReasons: string[]}|null} subject
 */
// eslint-disable-next-line import/prefer-default-export
export function useHoldCauses(subject) {
  const { value: causes, reading } = useLatestWatch(
    () => {
      const current = subject();

      return current?.clinicId && current?.value ? current : null;
    },
    (params, onValue, onError) => watchHeldItemsAbout(
      params,
      (items) => onValue(holdCausesIn(items, params.holdReasons)),
      onError,
    ),
    { initial: [], label: 'which causes hold a task' },
  );

  return { causes, reading };
} // useHoldCauses()
